export default __webpack_public_path__ + "static/media/ig.2aaa244a.png";